import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Button from '../../ui/Button';
import { 
  StarIcon,
  PencilSquareIcon 
} from '@heroicons/react/24/outline';

const userLang = navigator.language || navigator.userLanguage;

const OrderActionButtons = ({
  order,
  isMerchantContext,
  isUserContext
}) => {
  // All hooks must be called before any conditional logic
  const history = useHistory();
  const user = useSelector(state => state.auth.user);
  const loggedInUserId = user?.id;

  // Extract data for hook, but handle cases where order might be null
  const customerId = order?.users_permissions_user?.id;
  const orderId = order?.id;

  console.log('OrderActionButtons - Order data:', {
    orderId,
    customerId,
    loggedInUserId,
    hasComments: !!order?.comments,
    commentsLength: order?.comments?.length,
    comments: order?.comments
  });

  // Check for order-level comments (customer reviews linked to orders)
  const orderLevelComments = order?.comments?.filter(comment => {
    console.log('Checking comment:', comment);
    console.log('Comment merchants:', comment.merchants);
    console.log('Comment customers:', comment.customers);
    console.log('LoggedIn merchant ID:', loggedInUserId);
    console.log('Customer ID:', customerId);
    
    // Check if this is a customer review comment
    const isCustomerReview = comment.isReviewCustomer === true && comment.isReviewProduct === false;
    
    console.log('Is customer review:', isCustomerReview);
    
    // If this is not a customer review, skip
    if (!isCustomerReview) {
      console.log('Skipping - not a customer review');
      return false;
    }
    
    // For now, let's be more lenient and just check if it's a customer review
    // TODO: Add proper merchant/customer matching once we understand the data structure
    console.log('Found customer review comment:', comment.id);
    return true;
  }) || [];
  
  console.log('Filtered order level comments:', orderLevelComments);
  
  const existingOrderComment = orderLevelComments.length > 0 ? orderLevelComments[0] : null;
  
  // Use the order-level comment as the existing review
  const existingReview = existingOrderComment;

  // Now we can do conditional logic after all hooks are called
  if (!order || !isMerchantContext) {
    return null; // Only show for merchant view
  }

  // Check if merchant has delivered fulfillment groups for this order
  const hasDeliveredFulfillmentGroups = order.fulfillmentGroups?.some(fg => 
    fg.status === 'delivery_completed_to_customer' || 
    fg.status === 'pickup_completed_by_customer' ||
    fg.status?.includes('return_') // Any return status means delivered first
  );

  // Only show review action if there are delivered items and customer exists
  if (!hasDeliveredFulfillmentGroups || !customerId) {
    return null;
  }

  const handleReviewCustomer = () => {
    history.push(`/order/${orderId}/customer/${customerId}/review`, {
      orderId,
      customerId,
      authorMerchantId: loggedInUserId,
      orderNumber: order.orderNumber,
      ...(existingReview && { existingReview: existingReview })
    });
  };

  const isEditingReview = !!existingReview;
  
  // Update label based on whether there's an existing review
  let reviewLabel;
  if (isEditingReview) {
    reviewLabel = userLang === 'zh-CN' ? '修改评价' : 'Update Review';
  } else {
    reviewLabel = userLang === 'zh-CN' ? '评价买家' : 'Review Customer';
  }

  // Dynamic button variant based on review status
  const buttonVariant = isEditingReview ? 'secondary' : 'yellow'; // beige if reviewed, yellow if not

  return (
    <div className="flex gap-2 items-center justify-between w-full">
      <Button 
        variant={buttonVariant}
        onClick={handleReviewCustomer}
        className="text-xs px-2 py-1 whitespace-nowrap sm:px-3 sm:py-1.5"
      >
        {isEditingReview ? (
          <PencilSquareIcon className="h-4 w-4 mr-1 sm:mr-1.5" />
        ) : (
          <StarIcon className="h-4 w-4 mr-1 sm:mr-1.5" />
        )}
        {reviewLabel}
      </Button>
      
      {/* Payout requirement message - moved to right side */}
      <div className="flex flex-col justify-center text-right ml-auto">
        <p className="text-xs text-gray-600 font-medium">
          {userLang === 'zh-CN' ? '支付所需' : 'Review required for payout'}
        </p>
        {/* <p className="text-xs text-gray-500">
          {userLang === 'zh-CN' ? '30天后可提现（退货期限）' : '30-day wait (return period)'}
        </p> */}
      </div>
    </div>
  );
};

export default OrderActionButtons; 